import React from 'react'
import { AutocompleteComp } from './Autocomplete'
import { autocompUsuario } from '../services/servUsuarios'
import { FormatNombreUsuario } from '../utils/Formatter';

export const AutocompleteUsuario = ({onSelect, clearOnSelect, autoFocus, seleccion}) => {

    const itemLabel = (obj) => FormatNombreUsuario(obj)

    return <AutocompleteComp 
                serviceCall={autocompUsuario}
                label="TXT_USUARIO"
                itemLabel={itemLabel}
                onSelect={onSelect}
                clearOnSelect={clearOnSelect}
                autoFocus={autoFocus}
                seleccion={seleccion}
            />
};